var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "wrapper",
      attrs: { id: "sideBarModalComponent" },
      on: { click: _vm.onClose },
    },
    [
      _c("div", { class: { wrapper_body: true, open: true } }, [
        _vm.loading
          ? _c(
              "div",
              { staticClass: "loading_div" },
              [
                _c("pulse-loader", {
                  staticClass: "text-center",
                  attrs: { loading: _vm.loading, color: _vm.color },
                }),
              ],
              1
            )
          : _c(
              "div",
              { staticClass: "editBlock p-2" },
              [
                _c("Profile", {
                  attrs: {
                    updateRecord: _vm.updateRecord,
                    closeProfile: () => _vm.onClose(null, true),
                    managers: _vm.managers,
                    user: _vm.originalUser,
                    roles: _vm.roles,
                    tags: _vm.tags,
                  },
                }),
              ],
              1
            ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }